import React, { useEffect, useState } from "react";
import {
  MdArrowDropUp,
  MdOutlineCalendarToday,
  MdBarChart,
} from "react-icons/md";
import Card from "components/card";
import LineChart from "components/charts/LineChart";
import { lineChartOptionsTotalSpent } from "variables/charts";
import axios from "axios";
import { ApiUrl } from "Services/Services";

const TotalSpent = () => {
  const [totalSpent, setTotalSpent] = useState(0);
  const [percentageChange, setPercentageChange] = useState(0);
  const [chartData, setChartData] = useState([]);

  const fetchTotalSpent = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/order/analytics/totalSpent`);
      setTotalSpent(res.data.total || 0);
      setPercentageChange(res.data.change || 0);
      setChartData(res.data.chart || []);
    } catch (err) {
      console.error("Error fetching total spent:", err);
    }
  };

  useEffect(() => {
    fetchTotalSpent();
    const interval = setInterval(fetchTotalSpent, 10000); // refresh every 10s
    return () => clearInterval(interval);
  }, []);

  return (
    <Card extra="!p-[20px] text-center">
      {/* Header */}
      <div className="flex justify-between">
        <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:hover:opacity-90 dark:active:opacity-80">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-gray-600">This month</span>
        </button>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      {/* Content */}
      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="flex flex-col">
          <p className="mt-[20px] text-3xl font-bold text-navy-700 dark:text-white">
            Rs{ totalSpent.toLocaleString()}
          </p>
          <div className="flex flex-col items-start">
            <p className="mt-2 text-sm text-gray-600">Total Spent</p>
            <div className="flex flex-row items-center justify-center">
              <MdArrowDropUp className="font-medium text-green-500" />
              <p className="text-sm font-bold text-green-500">
                +{percentageChange}%
              </p>
            </div>
          </div>
        </div>

        {/* Chart */}
        <div className="h-full w-full">
          <LineChart
            options={lineChartOptionsTotalSpent}
            series={chartData}
          />
        </div>
      </div>
    </Card>
  );
};

export default TotalSpent;
